/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'gatsby';

import { StyledAuthor } from './AuthorStyles';
import { LazyImage } from '../../../../slices/atoms';

const Author = (authorObj, extraclass) => {
  const { author_image, author_name } = authorObj;
  const authorUid = authorObj._meta.uid;

  return (
    <StyledAuthor className={extraclass}>
      {author_image ? <LazyImage width="36px" src={author_image.url} alt={author_image.alt || 'author image'} /> : null}
      {author_name ? (
        <div>
          By <Link to={`/blog/author/${authorUid}`}>{author_name} </Link>
        </div>
      ) : null}
    </StyledAuthor>
  );
};
export default Author;
